import { isEqual } from 'lodash';
import React, { memo, useMemo, useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import ErrorBoundary from '../shared/ErrorBoundary';
import CustomHtmlBlock from './CustomHtmlBlock';

const MappedCustomHtmlBlock = memo(({ content, presentation, contentButtons }: any) => {
  const { datalayerVariant } = presentation;
  const {
    headField = '',
    stylesField = '',
    contentField = '',
    scriptsField = '',
    contentType = null,
  } = content;

  const customHtmlBlockProps = useMemo(
    () => ({
      headField,
      stylesField,
      contentField,
      scriptsField,
      template: contentType,
      datalayerVariant,
      contentButtons,
    }),
    [
      headField,
      stylesField,
      contentField,
      scriptsField,
      contentType,
      datalayerVariant,
      contentButtons,
    ],
  );

  return (
    <ErrorBoundary>
      <CustomHtmlBlock {...customHtmlBlockProps} />
    </ErrorBoundary>
  );
}, isEqual);

const CustomHtmlBlockCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        headField: 'headField',
        stylesField: 'stylesField',
        contentField: 'contentField',
        scriptsField: 'scriptsField',
        contentType: null,
      },
    ],
    componentParameterMap: [
      'presentation',
      {
        'variant-label': 'datalayerVariant',
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Custom HTML Block Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });
  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedCustomHtmlBlock}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default CustomHtmlBlockCMSWrapper;
